import React, { Component } from "react";
import PropTypes from "prop-types";
import { Radio, Divider, Select } from "antd";
import { isString } from "lodash";
const Option = Select.Option;
import FieldAggregation from "./charts/field-agg";
import DateHistogram from "./charts/date-histogram";

class Entities extends Component {
  static propTypes = {
    filter: PropTypes.object
  };

  static defaultProps = {
    filter: {}
  };

  state = {
    fieldDate: "opposition_filing_date",
    fieldDrilldownDate: this.props.filter.opposition_country === "US" ? "opposition_category" : "",
    sortByCategory: "number"
  };

  render() {
    const { filter } = this.props;
    const { fieldDate, fieldDrilldownDate } = this.state;
    const labelRenderer = v => v.toUpperCase();
    return (
      <div style={{ width: "100%", textAlign: "center", minWidth: 435 }}>
        {filter.opposition_country && isString(filter.opposition_country) ? (
          undefined
        ) : (
          <div>
            <FieldAggregation field="opposition_country" sortBy="number" size={20} labelRenderer={labelRenderer} filter={filter} />
            <Divider />
          </div>
        )}

        <Radio.Group value={this.state.fieldDate} onChange={e => this.setState({ fieldDate: e.target.value })}>
          <Radio.Button value="opposition_filing_date">{"Opposition Filing Date"}</Radio.Button>
        </Radio.Group>
        <Divider type="vertical" />
        <Select
          value={this.state.fieldDrilldownDate}
          placeholder="Drill-Down By"
          onChange={val => this.setState({ fieldDrilldownDate: val })}
          getPopupContainer={trigger => trigger.parentNode}
          style={{ width: 180 }}
        >
          <Option value="">{"None"}</Option>
          <Option value="opposition_country">{"Country"}</Option>
          {filter.opposition_country === "US" ? <Option value="opposition_category">{"Category"}</Option> : undefined}
        </Select>
        <DateHistogram filter={filter} fieldDate={fieldDate} field2={fieldDrilldownDate} />
        <Divider />
        <h3>{`Top Parent Companies`}</h3>
        <FieldAggregation field="assignee_parent" sortBy="number" size={20} labelRenderer={labelRenderer} filter={filter} />
        <Divider />
        <h3>{`Top CPC Classes`}</h3>
        <FieldAggregation field="cpc_class" sortBy="number" size={20} labelRenderer={labelRenderer} filter={filter} />
      </div>
    );
  }
}

export default Entities;
